<template>
    <div>
        <router-link :to="{name:'WorkYearPage',params:{year:year}}">{{year}}</router-link>
    </div>
</template>

<script>
    export default {
        name: "SidebarYear",
        props: ['year'],
        computed: {}
    }
</script>

<style scoped>

</style>